import { useMutation } from '@apollo/client';
import { CREATE_TOOL_TRANSFER } from '../gql/queries';

import { CreateToolTransferInput, CreateToolTransferResult } from '@bechtel/ht-types';
export interface CreateToolTransferInputData {
  createToolTransferInput: CreateToolTransferInput;
}
export const useCreateToolTransfer = (refetchQueries = ['SearchToolTransfers']) => {
  const [createToolTransferMutation, { data, loading, error }] = useMutation<
    CreateToolTransferResult,
    CreateToolTransferInputData
  >(CREATE_TOOL_TRANSFER);

  const createToolTransfer = (
    input: CreateToolTransferInput,
    onCompleted?: (data: any) => void,
    onError?: (data: any) => void
  ) => {
    createToolTransferMutation({
      variables: { createToolTransferInput: input },
      onCompleted: (data) => {
        onCompleted && onCompleted(data);
      },
      onError: (error) => {
        onError && onError(error);
      },
      refetchQueries: refetchQueries,
    });
  };

  return { createToolTransfer, data, loading, error };
};
